<template>
  <IndicatorCard
    :loading="loading"
    :has-data="equips.length > 0"
    :is-result="isResult"
    :no-data-message="$t('Nenhum equipamento encontrado')"
    :title="title"
    :description="indicator.description"
    :excel-endpoint="indicator.excelEndpoint"
    :hide-excel="!isResult"
    :excel-loading="excelLoading"
    @export-excel="requestExcel"
  >
    <template #date-range>
      <DateRangePicker
        :start-date="startDate"
        :end-date="endDate"
        :disabled="isResult"
        @change="onDateRangeChange"
      />
    </template>

    <v-row class="ma-0" justify="center">
      <v-col cols="12">
        <strong>Total: {{ total }}</strong>

        <div>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="equips"
            class="main-table"
            hide-default-header
            :hide-default-footer="!filterProp.data"
            :header-props="headerProps"
            :items-per-page="7"
            :mobile-breakpoint="0"
          >
            <template #header="{ props, on }">
              <thead>
                <tr>
                  <th
                    class="text-center"
                    v-for="header in props.headers"
                    :key="header.value"
                  >
                    <v-simple-checkbox
                      v-if="header.value === 'data-table-select'"
                      v-model="props.everyItem"
                      :indeterminate="props.someItems && !props.everyItem"
                      color="purple"
                      @input="on['toggle-select-all']"
                    ></v-simple-checkbox>

                    <div>
                      <v-hover v-slot="{ hover }">
                        <div>
                          <span>{{ $t(header.text) }}</span>
                          <v-icon
                            v-if="
                              hover &&
                              header.value != 'data-table-select' &&
                              header.value != 'actions'
                            "
                            color="white"
                            class="mx-2"
                            @click="on.sort(header.value)"
                          >
                            {{
                              props.options.sortBy.includes(header.value)
                                ? `mdi-chevron-down`
                                : `mdi-chevron-up`
                            }}
                          </v-icon>
                        </div>
                      </v-hover>
                    </div>
                  </th>
                </tr>
              </thead>
            </template>

            <template v-slot:[`item.identification`]="{ item }">
              {{ item.identification }}
            </template>

            <template v-slot:[`item.standardEquipmentName`]="{ item }">
              {{ item.standardEquipmentName }}
            </template>

            <template v-slot:[`item.dateFormated`]="{ item }">
              {{ item.dateFormated }}
            </template>

            <template v-slot:[`item.alienatedMotive`]="{ item }">
              {{ item.alienatedMotive }}
            </template>

            <template v-slot:[`item.model`]="{ item }">
              {{ item.model }}
            </template>
          </v-data-table>
          <div class="pagination" v-if="!filterProp.data">
            <div class="item-pagination block-two">
              <v-pagination
                class="pagination-item"
                v-model="page"
                :length="totalPages"
                :total-visible="9"
              ></v-pagination>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <template #review>
      <v-row class="ma-0">
        <v-col cols="12" v-if="isResult && review">
          <strong>{{ $t('Análise crítica') }}</strong>
          <p v-html="review"></p>
        </v-col>
        <v-col cols="12" v-else-if="!isResult">
          <tiptap-vuetify
            v-model="filter.review"
            :extensions="extensions"
            :label="$t('Análise crítica')"
            :placeholder="
              $t('Digite sua análise crítica para o indicador abaixo')
            "
            :card-props="{ flat: true, outlined: true, rounded: true }"
            class="primary-input"
            outlined
            dense
            hide-details="auto"
          ></tiptap-vuetify>
        </v-col>
      </v-row>
    </template>
  </IndicatorCard>
</template>

<script>
import { getIndicatorById } from '../../../../../indicators/indicatorRegistry'
import ApiService from '../../../../../../../../services/ApiService'
import moment from 'moment'
import IndicatorCard from '../../shared/IndicatorCard.vue'
import DateRangePicker from '../../shared/DateRangePicker.vue'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  props: {
    title: { type: String, default: '' },
    apiEndpointOverride: { type: String, default: '' },
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    IndicatorCard,
    DateRangePicker,
    TiptapVuetify,
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  data() {
    return {
      excelLoading: false,
      chartKey: false,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        page: 1,
        pageSize: 7,
        institutionId: null,
        review: '',
        unidadeIds: [],
        startDate: null,
        endDate: null,
      },
      startDate: null,
      endDate: null,
      apiService: new ApiService(),
      loading: true,
      equips: [],
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      calibrationSchedule: [],
      calibrationExecuted: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'identification',
        },
        {
          text: 'Nome padrão do equipamento',
          align: 'center',
          value: 'standardEquipmentName',
        },
        {
          text: 'Data de Alienação',
          align: 'center',
          value: 'dateFormated',
        },
        {
          text: 'Motivo',
          align: 'center',
          value: 'alienatedMotive',
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'model',
        },
      ],
      total: 0,
    }
  },

  computed: {
    indicator() {
      return getIndicatorById('alienated_equipment') || {}
    },
    totalInPeriod() {
      if (this.equips) {
        return this.total
      } else {
        return null
      }
    },
  },

  methods: {
    onDateRangeChange({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      this.filter.page = 1
      this.page = 1
      this.filterProp.data = null
      this.list()
    },

    requestExcel() {
      if (!this.indicator.excelEndpoint) return
      this.excelLoading = true
      const filename = `${this.indicator.legacyKey}.xlsx`
      this.apiService
        .post(this.indicator.excelEndpoint, {
          ...this.filter,
          pageSize: 999999,
        })
        .then((response) => {
          const data = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = data
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => {
          this.excelLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: getIndicatorById('alienated_equipment').legacyKey,
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },
    async list() {
      this.loading = true
      try {
        if (this.filterProp.data) {
          const response = JSON.parse(this.filterProp.data)
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
          this.equips = []

          this.showChart = response.content.objects.length > 0
          response.content.objects.map((value) => {
            let dateFormated = moment(value.alientedDate).format('DD/MM/YYYY')
            this.equips.push({ ...value, dateFormated })
          })

          this.fillequipsChartData()
          return
        }

        if (!this.isResult) this.setDates()
        this.filter.institutionId = this.institution.id
        this.filter.pageSize = 7
        this.filter.unidadeIds = this.unidades
        const response = await this.apiService.post(
          this.apiEndpointOverride || 'reports/alienatedEquipment',
          this.filter
        )
        this.total = response.content.pager.totalItems
        this.totalPages = response.content.pager.totalPages
        this.equips = []
        this.showChart = response.content.objects.length > 0
        response.content.objects.map((value) => {
          let dateFormated = moment(value.alientedDate).format('DD/MM/YYYY')
          this.equips.push({ ...value, dateFormated })
        })

        this.fillequipsChartData()
      } finally {
        this.loading = false
      }
    },
    fillequipsChartData() {
      this.equipsChartData = {
        labels: [''],
        datasets: [
          {
            label: this.$t('Calibrações Agendadas'),
            data: this.calibrationSchedule,
            backgroundColor: '#87AFA6',
          },
          {
            label: this.$t('Calibrações Executadas'),
            data: this.calibrationExecuted,
            backgroundColor: '#BAB3D3',
          },
        ],
      }
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
